module.exports = __webpack_public_path__ + "franchise-far_cry-mobile.png";